import { sessionEndpoint, sessionAppTypeEndpoint } from './endpoints'

import { optionsGET, optionsPOST, optionsDELETE } from './options'

const AuthenticationService = {
  logIn: (credentials) => fetch(sessionEndpoint(), optionsPOST(credentials, false))
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText || 'Login failed');
      }
      return response.json()
    })
    .then((response) => {
      if (response.jwt && response.user) {
        localStorage.setItem('user', JSON.stringify(response.user));
        localStorage.setItem('session', JSON.stringify({ jwt: response.jwt, exp: response.exp }));
      }
      return response
    })
    .catch((err) => {
      // Log the error for debugging and rethrow so callers can handle it
      // eslint-disable-next-line no-console
      console.error('AuthenticationService.logIn error:', err);
      return Promise.reject(err);
    }),

  logOut: () => fetch(sessionEndpoint(), optionsDELETE())
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText || 'Logout failed');
      }
      return response.json()
    })
    .then((response) => {
      if (response.jwt === 'revoked') {
        localStorage.removeItem('user')
        localStorage.removeItem('session')
      }
      return response
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('AuthenticationService.logOut error:', err);
      return Promise.reject(err);
    }),

  appType: () => fetch(sessionAppTypeEndpoint(), optionsGET())
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response.statusText || 'AppType request failed');
      }
      return response.json();
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('AuthenticationService.appType error:', err);
      return Promise.reject(err);
    }),
}

export default AuthenticationService;
